import { GalleryPrivateSticky } from './gallery-private-sticky';

export default GalleryPrivateSticky;
